/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Layout, Row, Col, Menu, Dropdown } from "antd";
import { Header } from "antd/es/layout/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "routes/Routes.Constant";
import { CaretDownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setUser, setUserDetail } from "store/slices/user.slice";
import { useAppSelector } from "hooks/reduxHooks";
import { getrawlingsartificonfigurationdata } from "api/services/product.api";
import { Artifisettings } from "api/IProduct";
import { setArtifiConfigurationsRedux } from "store/slices/productCustomizationSlice";
import { getPortalDetails } from "api/services/bannerDetails.api";
import { UserSvgIcon } from "Icon/Icon";
import type { MenuProps } from "antd";
import InactivityDetector from "./InactivityDetector/InactivityDetector";
import Logo from "../Logo/Logo";
import "./Header.scss";
import {
  setLockerPortalDetails,
  setPortalIdRedux,
  setPublishCatalogIdRedux,
} from "store/slices/landingPage.slice";

const HeaderComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const userString = localStorage.getItem("UserRecord");
  const userRecord = userString ? JSON.parse(userString) : null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);
  const [portalId, setPortalId] = useState<number>(0);
  const [artifConfigurations, setArtifiConfigurations] = useState<Artifisettings | undefined>();

  useEffect(() => {
    const userDetails = {
      id: userRecord?.UserId,
      firstName: userRecord?.FirstName,
      lastName: userRecord?.LastName,
      fullName: userRecord?.FullName,
    };
    dispatch(setUserDetail(userDetails));
    dispatch(setUser(userDetails));
  }, [userRecord, dispatch]);

  useEffect(() => {
    getPortalDetails()
      .then((response) => {
        const portalDetails = response?.data?.rawlingsMyLockerPortalDetailsModel;
        const { PortalId, PublishCatalogId } = portalDetails || {};

        if (portalDetails) {
          dispatch(setLockerPortalDetails({ lockerPortalDetails: portalDetails }));
        }
        setPortalId(PortalId);
        dispatch(setPortalIdRedux(PortalId));
        dispatch(setPublishCatalogIdRedux(PublishCatalogId));
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (portalId) {
      getrawlingsartificonfigurationdata(portalId || 0)
        .then((res) => {
          setArtifiConfigurations(res?.data?.AIZnodePortalSetting);
          dispatch(setArtifiConfigurationsRedux(res?.data?.AIZnodePortalSetting));
        })
        .catch((err) => {
          throw err;
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portalId]);

  useEffect(() => {
    const scriptElementJquery = document.createElement("script");
    scriptElementJquery.src = "https://code.jquery.com/jquery-1.7.min.js";
    document.body.appendChild(scriptElementJquery);
    return () => {
      document.body.removeChild(scriptElementJquery);
    };
  }, []);
  useEffect(() => {
    if (artifConfigurations?.DomainName) {
      const scriptElement = document.createElement("script");
      // eslint-disable-next-line max-len
      scriptElement.src = `${artifConfigurations?.DomainName}Script/SasIntegration/artifiintegration.js`;
      document.body.appendChild(scriptElement);
    }
  }, [artifConfigurations]);

  const logoutHandler = () => {
    localStorage.removeItem("UserRecord");
    navigate(ROUTES_PATH.HOMEPAGE);
  };

  const currentURL = location.pathname;

  useEffect(() => {
    // If the user is not logged in and tries to access the Lookup Config page,
    if (!userRecord && currentURL.includes(ROUTES_PATH.LOOKUP_CONFIG)) {
      navigate("/login?redirect_url=/lookup-config");
    }
  }, [userRecord, navigate, currentURL]);

  const activeRoute = (path: string) => {
    if (path === currentURL) return { borderBottom: "2px solid" };
    return {};
  };
  const mainMenu: MenuProps["items"] = [
    {
      key: "lookup-config",
      label: (
        <Link
          to={ROUTES_PATH.LOOKUP_CONFIG}
          onClick={() => {
            ReactGA.event({
              category: "lookup_config_click",
              action: "lookup config button clicked",
              label: "lookup config button clicked",
            });
          }}
          style={activeRoute(ROUTES_PATH.LOOKUP_CONFIG)}
        >
          Lookup Config
        </Link>
      ),
    },
    // {
    //   key: "back-to-rawling",
    //   label: (
    //     <Link to={ROUTES_PATH.RAWLINGS} target="_blank">
    //       {"Back to Rawlings.com"}
    //     </Link>
    //   ),
    // },
  ];

  const items: MenuProps["items"] = [
    {
      key: "my-profile",
      label: (
        <Link to={`${ROUTES_PATH.USER_PROFILE}`} title={"my-profile"}>
          {"My Profile"}
        </Link>
      ),
    },
    {
      key: "logout",
      label: <div onClick={logoutHandler}>{"Logout"}</div>,
    },
  ];

  return (
    <>
      <InactivityDetector />
      <Layout className="main-header">
        <Row gutter={5} className="header-wrapper">
          <Col span={24} className="header-style">
            <Header className="layout-header-style">
              <Row gutter={15} className="header-wrapper">
                <Col span={24} xxl={24} xs={24} md={24} lg={24}>
                  <div className="header-content">
                    <Link to="/" className="logo-wrapper">
                      <Logo
                        imageWidth={"100px"}
                        imageHeight={"auto"}
                        isPreview={false}
                        className={"headerLogo"}
                        imageUrl={lockerDetails?.lockerPortalDetails?.WebsiteLogoUrl || ""}
                      />
                    </Link>
                    <div className="right-header-nav flex-1">
                      {!userRecord ? (
                        <>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(ROUTES_PATH.LOGIN);
                            }}
                            className="my-profile-menu"
                          >
                            <span id="userNameHeader">{"Sign In "}</span>
                            <UserSvgIcon />
                          </a>
                        </>
                      ) : null}
                      {currentURL.includes(ROUTES_PATH.LOGIN) ? null : (
                        <>
                          {userRecord ? (
                            <Dropdown menu={{ items }} trigger={["click"]}>
                              <a onClick={(e) => e.preventDefault()} className="my-profile-menu">
                                <UserSvgIcon className="user-buddy" />
                                <label
                                  id="userNameHeader"
                                  style={{
                                    marginLeft: "5px",
                                  }}
                                  title={`${userRecord?.FirstName ? "" : ""} ${
                                    userRecord?.FirstName || ""
                                  }`}
                                >
                                  {`Hello${userRecord?.FirstName ? "," : ""} ${
                                    userRecord?.FirstName || ""
                                  }`}
                                </label>
                                <CaretDownOutlined />
                              </a>
                            </Dropdown>
                          ) : null}
                        </>
                      )}
                      <Menu
                        triggerSubMenuAction="click"
                        theme="light"
                        mode="horizontal"
                        items={mainMenu}
                        className="header-navigation"
                        overflowedIndicator={<CaretDownOutlined />}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Header>
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default HeaderComponent;
